module.exports = __webpack_public_path__ + "fbff9a32a6101ff279f96b202e415821.png";